// db/subscribePaginatedAndFiltered.ts
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { registerSubscription } from "@adornis/baseql/metadata/register.js";
import { subscribePaginated } from "@adornis/baseql/server/resolver/mongo.js";
import { AdornisFilter } from "../AdornisFilter.js";
var subscribePaginatedAndFiltered = (clazz, skip, limit, filter) => (gqlFields) => _subscribePaginatedAndFiltered(clazz._class, skip, limit, filter)(gqlFields);
var _subscribePaginatedAndFiltered = registerSubscription({
  operationName: "subscribePaginatedAndFiltered",
  type: () => [MongoEntity],
  params: [
    { name: "entityClass", type: () => String },
    { name: "skip", type: () => Int },
    { name: "limit", type: () => Int },
    { name: "filter", type: () => AdornisFilter }
  ],
  resolve: (entityClass, skip, limit, filter) => (gqlFields) => {
    const node = baseqlMetaData.entities.resolveNode(entityClass);
    const mainClass = node.type();
    const validClasses = baseqlMetaData.entities.validSubclasses(node);
    return subscribePaginated(
      mainClass,
      skip,
      limit,
      { $and: [{ _class: { $in: validClasses } }, filter.getMongoFilter()] },
      filter.getMongoOptions()
    );
  }
});
export {
  subscribePaginatedAndFiltered
};
